'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Box } from '@/components/atoms/Box';
import { Text } from '@/components/atoms/Text';
import { Heading } from '@/components/atoms/Heading';
import { RawButton } from '@/components/atoms/RawButton';
import type { FaqBlockProps } from './FaqBlock.props';
import { faqBlockStyles, faqItemButtonStyles } from './FaqBlock.styles';
const collapsedStyle = {
  gridTemplateRows: '0fr'
} as const;
const expandedStyle = {
  gridTemplateRows: '1fr'
} as const;
const FaqBlockDefault = t0 => {
  const $ = _c(14);
  const {
    heading,
    items
  } = t0;
  const [openKey, setOpenKey] = useState(null);
  if (!items?.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = key => {
      setOpenKey(prev => prev === key ? null : key);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggle = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = faqBlockStyles();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== heading) {
    t3 = heading && <Heading level={2} className="text-3xl font-bold mb-8 text-foreground">{heading}</Heading>;
    $[2] = heading;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== items || $[5] !== openKey) {
    let t5;
    if ($[7] !== openKey) {
      t5 = item => {
        const isOpen = openKey === item._key;
        return <Box key={item._key} className="py-4"><RawButton id={`faq-question-${item._key}`} onClick={() => toggle(item._key)} className={faqItemButtonStyles()} aria-expanded={isOpen} aria-controls={`faq-answer-${item._key}`} aria-label={item.question || undefined}><Text className="flex-1">{item.question}</Text><Box className={cn("transition-transform duration-200", isOpen ? "rotate-180" : "rotate-0")}><ChevronDown className="size-5 shrink-0 text-muted-foreground" /></Box></RawButton><Box id={`faq-answer-${item._key}`} role="region" aria-labelledby={`faq-question-${item._key}`} className="grid transition-[grid-template-rows] duration-300 ease-in-out" style={isOpen ? expandedStyle : collapsedStyle}><Box className="overflow-hidden"><Text as="p" className="pt-2 pb-4 text-muted-foreground leading-relaxed">{item.answer}</Text></Box></Box></Box>;
      };
      $[7] = openKey;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = items.map(t5);
    $[4] = items;
    $[5] = openKey;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <Box className="divide-y divide-border">{t4}</Box>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <Box className={t2}>{t3}{t5}</Box>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export { FaqBlockDefault };